const departments = {
  tech: {
    code: 1,
    text: " فنی ",
  },
  financial: {
    code: 2,
    text: " مالی و حسابداری ",
  },
  sale: {
    code: 3,
    text: " فروش ",
  },
  complaint: {
    code: 4,
    text: "انتقاد، پیشنهاد، شکایت",
  },
  order: {
    code: 5,
    text: " خرید با طرح سفارشی ",
  },
  return: {
    code: 6,
    text: " مرجوع کردن سفارش ",
  },
  etc: {
    code: 7,
    text: " سایر موارد ",
  },
};
export default departments;
